"use client";

import React from 'react';
import { cn } from '@/lib/utils';

interface CategoryFilterProps {
  categories: { title: string; slug: { current: string } }[];
  activeCategory: string | null;
  onSelect: (slug: string | null) => void;
}

export default function CategoryFilter({ categories, activeCategory, onSelect }: CategoryFilterProps) {
  return (
    <div className="flex flex-wrap justify-center gap-3 mb-16">

      <button
        onClick={() => onSelect(null)}
        className={cn(
          "px-6 py-2.5 rounded-full font-sans text-sm font-medium border transition-all duration-200",
          activeCategory === null
            ? "bg-bloom-green-deep border-bloom-green-deep text-white shadow-md shadow-bloom-green-deep/10"
            : "bg-transparent border-bloom-border text-bloom-muted hover:border-bloom-green-deep hover:text-bloom-green-deep"
        )}
      >
        All Articles
      </button>
      {categories.map((category) => (
        <button
          key={category.slug.current}
          onClick={() => onSelect(category.slug.current)}
          className={cn(
            "px-6 py-2.5 rounded-full font-sans text-sm font-medium border transition-all duration-200",
            activeCategory === category.slug.current
              ? "bg-deep-green border-deep-green text-cream shadow-md shadow-deep-green/10"
              : "bg-transparent border-border text-muted-foreground hover:border-deep-green hover:text-deep-green"
          )}
        >
          {category.title}
        </button>
      ))}
    </div>
  );
}
